// extracted by mini-css-extract-plugin
export default {"shopSettingsForm":"ShopSettingsPage_shopSettingsForm__1SESI"};